export const DICTIONARY_VALUE_CREATE_PATH = "/dictionaries/:dictionary/add";
